// extracted by mini-css-extract-plugin
export var numpadContainer = "_nt-1";
export var phoneButton = "_nt-0";